import React from "react";

const DataProductIcon = ({ color = "#424242", ...props }) => (
  <svg width={26} height={26} {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={13} cy={13} r={13} fill={color} fillRule="nonzero" />
      <path
        fill="#FFF"
        d="M15.81 15.215c-.497 0-.945.192-1.285.503l-4.66-2.717c.036-.147.059-.301.059-.458 0-.157-.023-.31-.059-.458l4.61-2.69c.35.326.818.529 1.335.529 1.082 0 1.962-.88 1.962-1.962C17.772 6.88 16.892 6 15.81 6c-1.083 0-1.962.88-1.962 1.962 0 .157.023.31.059.458l-4.61 2.69a1.947 1.947 0 0 0-1.335-.529c-1.082 0-1.962.88-1.962 1.962 0 1.082.88 1.962 1.962 1.962.517 0 .984-.203 1.334-.53l4.66 2.718a1.851 1.851 0 0 0-.053.428 1.906 1.906 0 1 0 1.907-1.906"
      />
    </g>
  </svg>
);

export default DataProductIcon;
